function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useContext, useState, useMemo, useRef } from "react";
import { useLayoutEffect } from "../../../hooks/useLayoutEffect";
import ThemeContext from "../../ThemeProvider/ThemeContext";
import buildStyle from "./ScrollViewWithBars.style";
import { BreakpointsContext } from "../../Breakpoints/BreakpointsProvider";
var FIXED_BARS_MIN_HEIGHT = 250;
export function ScrollViewWithBars(_param) {
    var children = _param.children, footer = _param.footer, _forceStickyFooter = _param.forceStickyFooter, forceStickyFooter = _forceStickyFooter === void 0 ? false : _forceStickyFooter, _forceStickyHeader = _param.forceStickyHeader, forceStickyHeader = _forceStickyHeader === void 0 ? false : _forceStickyHeader, forwardScrollViewRef = _param.forwardScrollViewRef, header = _param.header, id = _param.id, testId = _param.testId, rest = _objectWithoutProperties(_param, [
        "children",
        "footer",
        "forceStickyFooter",
        "forceStickyHeader",
        "forwardScrollViewRef",
        "header",
        "id",
        "testId"
    ]);
    var backupRefToForceRefresh = useRef();
    var scrollViewRef = forwardScrollViewRef || backupRefToForceRefresh;
    var ref = useBarShadow({
        forceStickyFooter: forceStickyFooter,
        forceStickyHeader: forceStickyHeader
    }), showHeaderShadow = ref.showHeaderShadow, showFooterShadow = ref.showFooterShadow, hasStickyHeader = ref.hasStickyHeader, hasStickyFooter = ref.hasStickyFooter, setBarsShadow = ref.setBarsShadow;
    var ref1 = useStyle({
        showHeaderShadow: showHeaderShadow,
        showFooterShadow: showFooterShadow
    }), outerContainerStyle = ref1.outerContainerStyle, scrollViewStyle = ref1.scrollViewStyle, headerStyle = ref1.headerStyle, footerStyle = ref1.footerStyle;
    useLayoutEffect(function() {
        var setBarsShadowOnResize = function setBarsShadowOnResize() {
            return setBarsShadow(scrollViewRef === null || scrollViewRef === void 0 ? void 0 : scrollViewRef.current);
        };
        setBarsShadowOnResize();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', setBarsShadowOnResize);
            return function() {
                return window.removeEventListener('resize', setBarsShadowOnResize);
            };
        }
    }, [
        children
    ]);
    return _jsxs("div", _objectSpread({}, rest, {
        css: outerContainerStyle,
        id: id,
        children: [
            header && hasStickyHeader && _jsx("div", {
                css: headerStyle,
                children: header
            }),
            _jsxs("div", {
                css: scrollViewStyle,
                ref: scrollViewRef,
                onScroll: function(event) {
                    setBarsShadow(event === null || event === void 0 ? void 0 : event.target);
                },
                id: id ? "".concat(id, "-scroll-view") : undefined,
                "data-cvent-id": testId,
                tabIndex: showHeaderShadow || showFooterShadow ? 0 : undefined,
                children: [
                    header && !hasStickyHeader && _jsx("div", {
                        css: headerStyle,
                        children: header
                    }),
                    children,
                    footer && !hasStickyFooter && _jsx("div", {
                        css: footerStyle,
                        children: footer
                    })
                ]
            }),
            footer && hasStickyFooter && _jsx("div", {
                css: footerStyle,
                children: footer
            })
        ]
    }));
}
function useStyle(param) {
    var showHeaderShadow = param.showHeaderShadow, showFooterShadow = param.showFooterShadow;
    var theme = useContext(ThemeContext);
    var breakpointsObject = useContext(BreakpointsContext);
    var ref = useMemo(function() {
        return buildStyle(theme);
    }, [
        theme
    ]), outerContainer = ref.outerContainer, scrollView = ref.scrollView, header = ref.header, footer = ref.footer;
    return {
        outerContainerStyle: _objectSpread({}, outerContainer.base, breakpointsObject.heightWindow ? {
            maxHeight: breakpointsObject.heightWindow
        } : {}),
        scrollViewStyle: _objectSpread({}, scrollView.base),
        headerStyle: _objectSpread({}, header.base, showHeaderShadow ? header.shadow : {}),
        footerStyle: _objectSpread({}, footer.base, showFooterShadow ? footer.shadow : {})
    };
}
function useBarShadow(param) {
    var forceStickyFooter = param.forceStickyFooter, forceStickyHeader = param.forceStickyHeader;
    var ref5 = _slicedToArray(useState(false), 2), showHeaderShadow = ref5[0], setShowHeaderShadow = ref5[1];
    var ref2 = _slicedToArray(useState(false), 2), showFooterShadow = ref2[0], setShowFooterShadow = ref2[1];
    var ref3 = _slicedToArray(useState(false), 2), hasStickyFooter = ref3[0], setHasStickyFooter = ref3[1];
    var ref4 = _slicedToArray(useState(false), 2), hasStickyHeader = ref4[0], setHasStickyHeader = ref4[1];
    var setBarsShadow = function(element) {
        if (!element) return;
        var _clientHeight = element.clientHeight, clientHeight = _clientHeight === void 0 ? 0 : _clientHeight, _scrollHeight = element.scrollHeight, scrollHeight = _scrollHeight === void 0 ? 0 : _scrollHeight, _scrollTop = element.scrollTop, scrollTop = _scrollTop === void 0 ? 0 : _scrollTop;
        var ref = typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.matchMedia) && typeof window.matchMedia === 'function' ? window.matchMedia("(max-height: ".concat(FIXED_BARS_MIN_HEIGHT, "px)")) : {
            matches: true
        }, hasTinyViewport = ref.matches;
        var nextShowHeaderShadow = !hasTinyViewport && scrollTop !== 0;
        setShowHeaderShadow(nextShowHeaderShadow);
        var nextShowFooterShadow = !hasTinyViewport && clientHeight !== scrollHeight - scrollTop;
        setShowFooterShadow(nextShowFooterShadow);
        var nextHasStickyHeader = !hasTinyViewport;
        setHasStickyHeader(nextHasStickyHeader);
        var nextHasStickyFooter = !hasTinyViewport && clientHeight < scrollHeight;
        setHasStickyFooter(nextHasStickyFooter);
    };
    return {
        showHeaderShadow: showHeaderShadow,
        showFooterShadow: showFooterShadow,
        hasStickyHeader: forceStickyHeader || hasStickyHeader,
        hasStickyFooter: forceStickyFooter || hasStickyFooter,
        setBarsShadow: setBarsShadow
    };
}
export default ScrollViewWithBars;
